export default function certificateSlider() {

    const ourTeamSlider = document.querySelector('.js-OurTeamSlider');

    if (!ourTeamSlider) {
        return false;
    }

    function initOurTeamSlider() {

        if (ourTeamSlider.childElementCount == 1) {
            return false;
        }

        if (window.innerWidth > 1200) {
            return false;
        }

        if (ourTeamSlider.childElementCount <= 2 && window.innerWidth <= 1200 && window.innerWidth > 540) {
            return false;
        }

        $('.js-OurTeamSlider').not('.slick-initialized').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            dotsClass: 'our-team_dots',
            prevArrow: '<button type="button" class="our-team_arrow-prev"></button>',
            nextArrow: '<button type="button" class="our-team_arrow-next"></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true,
                    }
                }
            ]
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( function(item) {
            window.addEventListener(item, script);
        });
    }

    adaptive(initOurTeamSlider);

}